import { IndustryMenu } from '@framework/types';
import { ROUTES } from '@lib/routes';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

const IndustriesTemplate = dynamic(
  () => import('@components/layouts/menu/templates/industries')
);

const IndustriesMenu = ({activeMenuShop, setActiveMenuShop}: any) => {
  const router = useRouter();

  function onClickIndustryItemHandler(item: IndustryMenu) {
    setActiveMenuShop?.(false);
    router.push(item.allShops ? ROUTES.SHOPS : `${ROUTES.SHOPS}/${item.slug}`);
  }

  return (
    <IndustriesTemplate onClickIndustryItemHandler={onClickIndustryItemHandler} activeMenuShop={activeMenuShop} />
  );
};

export default IndustriesMenu;
